const environments = {
    dev: {
      aws_project_region: "us-gov-west-1",
      aws_cognito_region: "us-gov-west-1",
      aws_user_pools_id: "us-gov-west-1_UJKkhzxqp",
      aws_user_pools_web_client_id: "5d313dmen44vs9iblr8imiohj4",
      oauth: {},
      aws_cognito_username_attributes: ["EMAIL"],
      aws_cognito_signup_attributes: ["EMAIL", "NAME"],
      aws_cognito_mfa_configuration: "OFF",
      aws_cognito_mfa_types: ["SMS"],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
      },
      aws_cognito_verification_mechanisms: ["EMAIL"],
    },
    qa: {
      aws_project_region: "us-gov-west-1",
      aws_cognito_region: "us-gov-west-1",
      aws_user_pools_id: "us-gov-west-1_CHJEYNWw1",
      aws_user_pools_web_client_id: "222elugdnk869rt82lkptjterm",
      oauth: {},
      aws_cognito_username_attributes: ["EMAIL"],
      aws_cognito_signup_attributes: ["EMAIL", "NAME"],
      aws_cognito_mfa_configuration: "OFF",
      aws_cognito_mfa_types: ["SMS"],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
      },
      aws_cognito_verification_mechanisms: ["EMAIL"],
    },
    demo: {
      aws_project_region: "us-gov-west-1",
      aws_cognito_region: "us-gov-west-1",
      aws_user_pools_id: "us-gov-west-1_k3ts0TYbi",
      aws_user_pools_web_client_id: "2n8o8kdv5jfji77fs553sl4b72",
      oauth: {},
      aws_cognito_username_attributes: ["EMAIL"],
      aws_cognito_signup_attributes: ["EMAIL", "NAME"],
      aws_cognito_mfa_configuration: "OFF",
      aws_cognito_mfa_types: ["SMS"],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
      },
      aws_cognito_verification_mechanisms: ["EMAIL"],
    },
    prod: {
      aws_project_region: "us-gov-west-1",
      aws_cognito_region: "us-gov-west-1",
      aws_user_pools_id: "us-gov-west-1_yuexkQKkl",
      aws_user_pools_web_client_id: "u6e3ij7k12r2fkfnf82rbt8qc",
      oauth: {},
      aws_cognito_username_attributes: ["EMAIL"],
      aws_cognito_signup_attributes: ["EMAIL", "NAME"],
      aws_cognito_mfa_configuration: "OFF",
      aws_cognito_mfa_types: ["SMS"],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
      },
      aws_cognito_verification_mechanisms: ["EMAIL"],
    }
  };
  
  // 🔹 Detect environment from `window.location.hostname`
  const hostname = window.location.hostname;
  let env = "dev"; // Default to dev
  
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    env = "dev";  // Explicitly use `dev` for localhost
  } else if (hostname === "dev.reporting.guardify.com") {
    env = "dev";
  } else if (hostname === "qa.reporting.guardify.com") {
    env = "qa";
  } else if (hostname === "demo.reporting.guardify.com") {
    env = "demo";
  } else if (hostname === "reporting.guardify.com") {
    env = "prod";
  }
  
  // Export the correct environment config
  const awsConfig = environments[env];
  
  
  export default awsConfig;
  